import { render, staticRenderFns } from "./IntroMain.vue?vue&type=template&id=76caa21d&scoped=true"
import script from "./IntroMain.vue?vue&type=script&lang=js"
export * from "./IntroMain.vue?vue&type=script&lang=js"
import style0 from "./IntroMain.vue?vue&type=style&index=0&id=76caa21d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76caa21d",
  null
  
)

export default component.exports